module.exports = __webpack_public_path__ + "img/2.a89c64d1.jpg";